import React, { useEffect, useState } from 'react'

import './PaymentFailedComponent.css'
import { MdErrorOutline } from "react-icons/md";
import { useNavigate } from "react-router-dom";
;


const PaymentFailedComponent = () => {
    const router = useNavigate();
    const [transactionId, setTransactionId] = useState();
    useEffect(() => {
        const location = window.location.pathname?.split('=')?.[1];
        // const location = window.location.hash?.split('=')?.[1];

        setTransactionId(location)
        // const tranId = location.split('=');

    }, [])
    return (


        <div className='payment_failed' style={{flex:"1"}}>
            <div className='payment_dvi'>
                <div className='icon_div'>

                    <MdErrorOutline className='fail_icon' />
                </div>

                <hr />
                <p className='payment_failed_p'>Payment Failed</p>
                <div className='trans_div'>
                    <p>Transaction Id:  </p>



                    <p>{transactionId}</p>
                </div>
                <div className="trans_div">
                    <p className='support_div'>
                        For Support:
                    </p>
                    <button type="button" className="common_btn btn-primary contact_banner" onClick={() => router("/contactus")}>
                        Contact Us
                    </button>
                    <button type="button" className="common_btn btn-primary contact_banner" onClick={() => router("/")}>
                       Home
                    </button>

                </div>


            </div>

        </div >
    )
}

export default PaymentFailedComponent
